import { createBrowserRouter } from 'react-router-dom';

import MainRoutes from './MainRoutes';
import AuthRoutes from './AuthRoutes';

// ==============================|| ROUTER ||============================== //

const router = createBrowserRouter(
  [MainRoutes, AuthRoutes],
  { basename: import.meta.env.SX_VITE_APP_BASE_URL || '/' }
);

export default router;
